module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3rn8q"))).then(() => parcelRequire('d3GEA'));